import { FormControl, FormGroup } from '@angular/forms';
import { IWaitListItem } from '@internal-models/wait-list-item.model';
import { IFormGroup } from '@shared-libs/interfaces';
import { ClientFormFactory } from './client-form.factory';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IEvent } from '@internal-models/event.model';
import { Action } from '@shared-libs/enums';

export class WaitListItemFormFactory {
	public static create(action: Action, waitListItem?: IWaitListItem, event?: IEvent): IFormGroup<IWaitListItem> {
		return new FormGroup({
			id: new FormControl(waitListItem?.id),
			description: new FormControl(waitListItem?.description),
			type: new FormControl(waitListItem?.type ?? event?.EventType.name, [SharedFormValidators.required]),
			status: new FormControl(waitListItem?.status),
			...(action === Action.CREATE ? { Client: ClientFormFactory.createForWaitList(waitListItem?.Client) } : {}),
			EventId: new FormControl(event?.id),
		}) as IFormGroup;
	}

	public static getValue(action: Action, waitListItemForm: IFormGroup<IWaitListItem>): Partial<IWaitListItem> {
		return {
			...waitListItemForm.value,
			...(action === Action.CREATE
				? { Client: ClientFormFactory.getValue(waitListItemForm.get('Client') as IFormGroup) }
				: {}),
		};
	}
}
